import cn from 'classnames'
import { NoteLib, type NoteDegree as NoteDegreeType } from '@tunasong/music-lib'
import type { FC, HTMLAttributes } from 'react'
import styles from './note-degree.module.css'

export interface NoteDegreeProps extends HTMLAttributes<HTMLSpanElement> {
  degree: NoteDegreeType
}

export const NoteDegree: FC<NoteDegreeProps> = ({ degree, style, className, ...restProps }) => (
  <span
    contentEditable={false}
    className={cn(styles.degree, className)}
    style={style}
    {...restProps}
  >
    {NoteLib.prettifyNote(degree)}
  </span>
)
